import { createGlobalStyle } from 'styled-components';
import backgroundImg from './Error/svgs/background.svg';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0px;
    padding: 0px;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
  }

  body {
    background-image: url(${backgroundImg});
    background-color: ${({ bgColor }) => (bgColor || '#195343')};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export default GlobalStyle;
